/**
 * System Imports
*/

import { Config, ConfigInit } from '@system/Config';
import { EmoteInitBTTV } from '@system/Emote';
import { TwitchInit } from '@system/Twitch';

/**
 * Relative Imports
*/

import { ChatBoxInit } from './ChatBox';

/**
 * Functions
*/

/**
 * @return {Promise<void>}
 */
async function ApplicationStart(): Promise<void>
{
    await ConfigInit();

    if (Config('twitchid')) {
        await EmoteInitBTTV(Config('twitchid'));
    }

    if (Config('bttvids')) {
        let ids = Config('bttvids').split(',');
        let i = ids.length;

        while (i--) {
            await EmoteInitBTTV(ids[i]);
        }
    }

    await ChatBoxInit();
    await TwitchInit(Config('username'), Config('oauth'), Config('channel'));
}

/**
 * Main
*/

ApplicationStart();
